/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import router from '../router'
import {$api} from '@/assets/helper'
const actions = {

    // ////////////////////////////////////////////
    // SIDEBAR & UI UX
    // ////////////////////////////////////////////

    updateSidebarWidth({ commit }, width) {
      commit('UPDATE_SIDEBAR_WIDTH', width);
    },
    toggleContentOverlay({ commit }) {
      commit('TOGGLE_CONTENT_OVERLAY');
    },
    updateTheme({ commit }, val) {
      commit('UPDATE_THEME', val);
    },
    updateWindowWidth({ commit }, width) {
      commit('UPDATE_WINDOW_WIDTH', width);
    },


    // ////////////////////////////////////////////
    // COMPONENT
    // ////////////////////////////////////////////

    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
      commit('UPDATE_STARRED_PAGE', payload)
    },

    //  The Navbar
    arrangeStarredPagesLimited({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_LIMITED', list)
    },
    arrangeStarredPagesMore({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_MORE', list)
    },
    logout({ commit }){
      localStorage.clear() 
      router.push('/pages/login')
      delete $api.defaults.headers["Authorization"]
      commit('CLEARAUTH')
      
    },
    async postData({commit},req){
      return new Promise((resolve, reject) => {
        console.log('REQQQQQQQQQQ', req)
        $api[req.method]('/'+req.route, req.data).then(x => {
          if (x.status === 200){
            if (x.data.id){
              resolve({success:true,data:x.data})
            } else {
              resolve({success:false,data:x.data})
            }
          }
        }).catch(err => {
          resolve({success:false, message:err})
        })
        
      })
    }
}

export default actions
